import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { modalMetadata } from 'src/app/document-management/models/metadata-modal';

@Component({
  selector: 'app-modal-metadata',
  templateUrl: './modal-metadata.component.html',
  styleUrls: ['./modal-metadata.component.css']
})
export class ModalMetadataComponent implements OnInit {

  data : modalMetadata;

  constructor(private modalConfig : DialogConfig) { }

  ngOnInit() {
    this.data = this.modalConfig.data.metadata;
  }

}
